import { rotate } from '../animations.js';

var loader = {
    base: {
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        width: "100%",
        height: "100%",
    },
    variants: {
        variant: {
            "sm-center": { "--icon-size": "24px", flexDirection: "column" },
            "md-center": { "--icon-size": "32px", flexDirection: "column" },
            "lg-center": { "--icon-size": "48px", flexDirection: "column" },
        },
        size: {
            sm: {
                "--icon-size": "18px",
            },
            md: {
                "--icon-size": "20px",
            },
            lg: {
                "--icon-size": "24px",
            },
        },
    },
    variantOrder: ["size", "variant"],
};
var loaderIcon = {
    base: {
        boxSizing: "border-box",
        display: "inline-block",
        lineHeight: 0,
        color: "primary.100",
        fontSize: "var(--icon-size)",
        mr: 2,
        animationName: rotate,
        animationDuration: "1.5s",
        animationTimingFunction: "linear",
        animationIterationCount: "infinite",
    },
    variants: {
        alignment: {
            center: {
                mb: 5,
            },
        },
    },
    defaultProps: {
        alignment: "left",
    },
};

export { loader, loaderIcon };
//# sourceMappingURL=loader.js.map
